import {Component, ElementRef, inject, Input, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {BreadcrumbItem} from "src/app/core/models/BreadcrumbItem";
import {ProjectName} from "src/app/core/models/Project";
import {ProjectService} from "src/app/core/services/services/project.service";
import {DataService} from "src/app/core/services/services/data.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {MatFormField, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {SanitizeInputDirective} from "../../../../shared/inputdirectives/sanitize-input.directive";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ProjectAutocompleteComponent} from "../../../../shared/autocomplete/components/project-autocomplete.component";

@Component({
	selector: "app-breadcrumb-project-search",
	templateUrl: "./breadcrumb-project-search.component.html",
	styleUrls: ["./breadcrumb-project-search.component.scss"],
	imports: [
		MatFormField,
		MatInput,
		MatAutocompleteTrigger,
		SanitizeInputDirective,
		MatIconButton,
		MatSuffix,
		MatIcon,
		ProjectAutocompleteComponent,
	],
})
@UntilDestroy()
export class BreadcrumbProjectSearchComponent implements OnInit {
	@Input() breadcrumb: BreadcrumbItem;
	currentProject: ProjectName;
	readonly detailPath: string = "/project-edit/";

	@ViewChild("projectInput") projectInput: ElementRef;

	private readonly _projectService = inject(ProjectService);
	private readonly _router = inject(Router);
	private readonly _dataService = inject(DataService);

	ngOnInit(): void {
		this._dataService.currentProject.pipe(untilDestroyed(this)).subscribe((currentProject) => {
			const subPath = this.breadcrumb.path.substring(
				this.breadcrumb.path.lastIndexOf(this.detailPath) + this.detailPath.length,
			);
			const sharePointId = subPath.lastIndexOf("/") > 0 ? subPath.substring(0, subPath.lastIndexOf("/")) : subPath;
			if (currentProject?.sharePointId === sharePointId) {
				this.currentProject = currentProject;
			} else {
				this._projectService.getProjectData(sharePointId).subscribe({
					next: (project) => (this.currentProject = project),
					error: () => {},
				});
			}
		});
	}

	onItemChange(project: ProjectName) {
		this._dataService.changeProject(project);
		this._router.navigate([this.detailPath + project.sharePointId]).then();
	}

	onClear() {
		this.projectInput.nativeElement.value = "";
	}

	onLeaveText() {
		// deferred so a click on an autocomplete option (which blurs the input first) is processed before we reset the value
		setTimeout(() => {
			this.projectInput.nativeElement.value = this.currentProject.client
				? this.currentProject.client + " - " + this.currentProject.projectName
				: this.currentProject.projectName;
		});
	}
}
